import userService from "../../../services/user-service";
import iconv from 'iconv-lite';
export const SEND_OTP = 'SEND_OTP'
export const RESET_PASSWORD = 'RESET_PASSWORD'

export function sendOtp(email) {
  return (dispatch, getState) => {
    return userService.sendOtp(email)
      .then((otpDetails) => {
        let response = _.get(otpDetails,'response',[])
        let decoded = iconv.decode(Buffer.from(_.get(response,'data',[])), 'win1251')
        dispatch({
          type: SEND_OTP,
          otpInfo: JSON.parse(decoded)
        })
      })
  }
}
export function resetPassword(body) {
  return (dispatch, getState) => {
    return userService.resetPassword(body)
      .then((resetStatus) => {
        dispatch({
          type: RESET_PASSWORD,
          resetStatus: resetStatus
        })
      })
  }
}

export function forgotPasswordReducer(state = {}, action) {
  switch (action.type) {
    case SEND_OTP: {
      return action.otpInfo
    }
    default:
      return state
  }
}

export function resetPasswordReducer(state = {}, action) {
  switch (action.type) {
    case RESET_PASSWORD: {
      return action.resetStatus
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/ForgotPassword/modules/ForgotPassword.js